// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0d1db91d","977":"fa9c709c"}[chunkId] + ".chunk.js";
};